import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUserPlus, FiShield, FiDollarSign } = FiIcons;

export default function HowItWorks() {
  const steps = [
    {
      icon: FiUserPlus,
      title: 'Step 1',
      description: 'Sign up using the link',
    },
    {
      icon: FiShield,
      title: 'Step 2',
      description: 'Verify your identity (takes a few minutes)',
    },
    {
      icon: FiDollarSign,
      title: 'Step 3',
      description: 'Make a small deposit to unlock your free stock',
    },
  ];

  return (
    <section className="py-20 bg-gray-50 border-y border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">How It Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center relative">
              <div className="w-16 h-16 mx-auto bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-6">
                <SafeIcon icon={step.icon} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}